module.exports = __webpack_public_path__ + "static/media/06-TRAILER.43e65dd9.png";